import axios from "axios";

let appSettings = {
	settings: undefined,
	fetching: undefined // will become a promise
}

/**
 * The fetcher to go get the settings
 * @returns {Promise<unknown>}
 */
appSettings.fetch = () => {
		if (typeof appSettings.settings !== 'undefined') {
			return new Promise((resolve) => { resolve(appSettings.settings) });
		}
		appSettings.fetching = new Promise((resolve, reject) => {
			axios.get(process.env.BASE_URL + 'settings/settings.json').then((res) => {
				appSettings.set(res.data);
				resolve(appSettings.settings);
			})
			.catch(() => {
				reject('Failed to get app settings');
			});
		});
		return appSettings.fetching;
}

/**
 * Get the settings, this handles fetching the settings if we haven't got them already
 * @returns {Promise<unknown>}
 */
appSettings.get = () => {
	// if we have settings then return the settings
	if (typeof appSettings.settings !== 'undefined') {
		return new Promise((resolve) => {
			resolve(appSettings.settings);
		});
	}
	// if we have no settings and are fetching settings then return the fetching promise
	if (typeof appSettings.settings === 'undefined' && typeof appSettings.fetching !== 'undefined') {
		return appSettings.fetching;
	}

	// if we have no settings and are not currently getting the settings then fetch the settings
	return appSettings.fetch();
}

/**
 * Simple setter to set the settings
 * @param settings
 */
appSettings.set = (settings) => {
	appSettings.settings = settings;
}

export default appSettings;
